// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../client';
import theme from '../../styled-components/dark';
import { withOpacity } from '../../styled-components/dark/helpers';
import { type CardMode, CardModes } from '../../types/common';
import BigBoostedOddCardContent from '../BigBoostedOddCardContent';
import BoostedOddCardContent from '../BoostedOddCardContent';
import MatchCardHeader, { MatchCardHeaderTimerClassName } from '../MatchCardHeader';

const BoostedOddWrapper = styled.div`
  padding: ${Target.__MOBILE__ ? '0 10px 10px 10px' : '10px'};
`;

const Wrap = styled.div`
  ${({ $cardMode }) => css`
    border: 1px solid ${withOpacity(theme.BoostedOddCard.borderColor[$cardMode], '99')};
  `}

  border-top: none;
  border-radius: 1em;
`;

const sharedContentStyles = css`
  border-radius: 0 0 1em 1em;
`;

const StyledBigBoostedOddCardContent = styled(BigBoostedOddCardContent)`
  ${sharedContentStyles}
`;

const StyledBoostedOddCardContent = styled(BoostedOddCardContent)`
  ${sharedContentStyles}
  --BoostedOddCard-contentMaxHeight: 19em;
  max-height: var(--BoostedOddCard-contentMaxHeight);
`;

const StyledCardHeader = styled(MatchCardHeader)`
  font-size: 0.8em;
  height: 2em;
  z-index: 10;

  ${({ $cardMode }) => css`
    background-image: ${theme.OddButton[$cardMode]?.headerColor ?? theme.OddButton[$cardMode]?.backgroundGradiant};

    .${MatchCardHeaderTimerClassName} {
      color: ${theme.MatchCardHeader[$cardMode]?.color};
    }

    .badge {
      border: 1px solid ${theme.BoostedOddCard.badge[$cardMode]?.color};
      z-index: 5;
      background-image: ${theme.BoostedOddCard.badge[$cardMode]?.backgroundImage};
      position: relative;
      border-radius: 1em 0;
      box-shadow:
        inset 0 0 0px 2px black,
        0.12em 0.12em 0.4em 0 rgb(0 0 0 / 80%);
      box-sizing: border-box;
    }

    .badgeWrapper:before {
      border-top: 1.31em solid ${theme.OddButton[$cardMode]?.borderColor};
    }

    .boostedIcon {
      color: ${theme.BoostedOddCard.badge[$cardMode]?.iconColor};
    }
  `}
`;

const CardModeRelativeContent = (props) => {
  const { cardMode } = props;

  if (cardMode === CardModes.BIG_BOOSTED) {
    return <StyledBigBoostedOddCardContent {...props} />;
  }

  return <StyledBoostedOddCardContent {...props} />;
};

type BoostedOddCardProps = {
  className?: string;
  matchId: number;
  categoryId: number;
  startDate: number;
  showFavorite: boolean;
  sportId: number;
  image: string | null;
  subTitle: string | null;
  isLive: boolean | null;
  cardMode: CardMode;
  oldValue?: number;
  newValue: number;
  outcomeLabel: string;
  onClick: (...params: unknown) => unknown;
  betId: number;
  oddId: number;
  selected?: boolean;
  isFavorite: boolean;
  onFavoriteButtonClicked: (...params: unknown) => unknown;
  uuid?: string;
  isCompact?: boolean;
};

const BoostedOddCard = (props: BoostedOddCardProps) => {
  const {
    className,
    matchId,
    categoryId,
    startDate,
    showFavorite,
    sportId,
    isLive = false,
    cardMode,
    isFavorite,
    onFavoriteButtonClicked,
  } = props;

  return (
    <BoostedOddWrapper className={className}>
      <Wrap $cardMode={cardMode}>
        <StyledCardHeader
          isLive={isLive}
          showFavorite={showFavorite}
          sportId={sportId}
          categoryId={categoryId}
          startDate={startDate}
          isFavorite={isFavorite}
          onFavoriteButtonClicked={onFavoriteButtonClicked}
          cardBadgeHasAttach
          matchId={matchId}
          $cardMode={cardMode}
        />
        <CardModeRelativeContent {...props} />
      </Wrap>
    </BoostedOddWrapper>
  );
};

export default React.memo<BoostedOddCardProps>(BoostedOddCard);
